/*
	Sometimes you don't know how many arguments you will have to pass 
	into $.when. This lets you pass an array of $.ajax calls of whatever
	length you happen to have.
	See https://stackoverflow.com/a/41441758/52174 (version 2)	
*/
$.whenAll = function(promises) {
    var d = $.Deferred();
    var results = [];
    var counter = promises.length;
    promises.forEach(function(promise, index) {
        promise
            .done(function(result) {
            results[index] = result;
            if (--counter == 0) {
              // All done
                d.resolve(results);
            }
          })
          .fail(function() {
            d.reject(Array.prototype.slice.call(arguments));
          });
    });
    return d.promise();
};